var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',_vm._b({},'label',_vm.$attrs,false),[(_vm.value)?_c('sg-text',{attrs:{"regular":"","gray":"","tag":"span"}},[_vm._v(_vm._s(_vm.value))]):_c('sg-text',{attrs:{"regular":"","gray":"","tag":"span"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }